document.addEventListener('DOMContentLoaded', async () => {
  await import('helpers/prefetch').then((module) => module.default.init())

  // SHARED SPECIFIC
  const helpers = await import('helpers/helpers').then((module) => {
    return module
  })

  helpers.checkFrameRate()
  helpers.pageRestore()
  helpers.verticalResizeCheck()

  document.querySelector('.body').classList.remove('noscript')

  if (document.querySelector<HTMLElement>('.pipes')) {
    await import('helpers/pipe-helpers').then((module) => module.pipeHelpers.init())
  }

  if (document.querySelector<HTMLElement>('.body')) {
    import('helpers/smooth-scroll').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.breadcrumbs')) {
    import('shared/sections/breadcrumbs').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header')) {
    import('shared/sections/header').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header-navigation')) {
    import('shared/components/header-navigation').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.hero')) {
    import('shared/sections/hero').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.banner')) {
    import('shared/sections/banner').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.picture')) {
    import('shared/components/picture').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.swiper')) {
    import('shared/components/swiper').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.video')) {
    import('shared/components/video').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.contact-form')) {
    import('shared/components/form').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.styled-select__container')) {
    import('shared/components/styled-select').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.full-width-image-block')) {
    import('shared/blocks/full-width-image-block').then((module) => module.default.init())
  }

  // HS ORKA SPECIFIC
  if (document.querySelector<HTMLElement>('.accordion')) {
    import('hsorka/components/accordion').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.article')) {
    import('hsorka/components/article').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.auth-form')) {
    import('hsorka/components/auth-form').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.article-video-block')) {
    import('hsorka/blocks/video-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.article-video-block__video-embed')) {
    import('hsorka/components/video-overlay').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.chat')) {
    import('hsorka/components/chat').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.search')) {
    import('hsorka/components/search').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.subnavigation')) {
    import('hsorka/components/subnavigation').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.staff-list')) {
    import('hsorka/components/staff-search').then((module) => module.default.init())
  }

  // if (document.querySelector<HTMLElement>('.world-goals-block')) {
  //   import('hsorka/components/world-goals').then((module) => module.default.init())
  // }

  if (document.querySelector<HTMLElement>('.faq')) {
    import('hsorka/components/faq').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('#mypageContent')) {
    import('hsorka/react/Containers/MypageContent').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.footer')) {
    import('shared/sections/footer').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.register-page')) {
    import('hsorka/components/register').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-file')) {
    import('hsorka/components/input-file').then((module) => module.default.init())
  }

  // SHARED SPECIFIC
  if (document.querySelector<HTMLElement>('.pipes')) {
    import('shared/components/block-pipes').then((module) => module.default.init())
  }

  if (!helpers.isProduction) {
    helpers.contentEditable.init()
    import('helpers/overlay-grid').then((module) => module.default.init())
  }

  helpers.removePreload()
})
